const TELEMETRY_ENABLED = import.meta.env.PROD;
const API_BASE = import.meta.env.VITE_API_URL || '/api';

// Rate limiting: 동일한 에러 메시지가 10초 내 반복되면 스킵
const recentErrors = new Map<string, number>();
const DEDUPE_WINDOW_MS = 10000;

export function reportError(
  error: Error,
  context?: { pageName?: string; userId?: string },
) {
  if (!TELEMETRY_ENABLED) {
    console.error('[Telemetry]', error, context);
    return;
  }

  const key = `${error.message}|${context?.pageName || ''}`;
  const now = Date.now();
  const last = recentErrors.get(key);
  if (last && now - last < DEDUPE_WINDOW_MS) return;
  recentErrors.set(key, now);

  // Clean up old entries
  if (recentErrors.size > 100) {
    for (const [k, t] of recentErrors.entries()) {
      if (now - t > DEDUPE_WINDOW_MS) recentErrors.delete(k);
    }
  }

  const body = {
    message: error.message,
    stack: error.stack,
    url: window.location.href,
    userAgent: navigator.userAgent,
    pageName: context?.pageName,
    userId: context?.userId,
  };

  // fetch with keepalive for reliability during unload
  fetch(`${API_BASE}/telemetry/error`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
    keepalive: true,
  }).catch(() => {}); // silent fail
}

export function reportPerformance(name: string, value: number) {
  if (!TELEMETRY_ENABLED) {
    console.log(`[Perf] ${name}=${value}`);
    return;
  }
  fetch(`${API_BASE}/telemetry/performance`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ name, value, url: window.location.href }),
    keepalive: true,
  }).catch(() => {});
}

// Global window.onerror + unhandledrejection 리스너
export function initGlobalErrorReporting() {
  window.addEventListener('error', (e) => {
    if (e.error) reportError(e.error, { pageName: 'global' });
  });
  window.addEventListener('unhandledrejection', (e) => {
    const error =
      e.reason instanceof Error ? e.reason : new Error(String(e.reason));
    reportError(error, { pageName: 'global-promise' });
  });
}
